import React from "react";
import { Box, Container, Grid, Typography, IconButton, TextField, Button, Divider } from "@mui/material";
import { Facebook, Twitter, YouTube, Instagram, Pinterest, Email, Phone, LocationOn } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
 import { Link } from 'react-router-dom';
const Footer = () => {
  return (
    <Box component="footer" sx={{ bgcolor: "#0a0a0a", color: "white", pt: 5, pb: 3 }}>
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          {/* Left Section - Brand & Social Media */}
          <Grid item xs={12} sm={4}>
            <Box display="flex" alignItems="start" justifyContent="center" flexDirection="column" mb={4}>
             <a href="/"><img src="/assets/urbancasa-updated-logo.png" alt="Urban Casa" width={168} height={140} style={{ borderRadius: "0%" }} /></a> 
              {/* <Typography variant="h6" sx={{ fontWeight: "bold", color: "#A0FF74", ml: 1 }}>
                Urban Casa
              </Typography> */}
            </Box>
            <Typography
  variant="body1"
  sx={{
    opacity: 0.7,
    width: { xs: "100%", lg: "35vw" },
    display: "block", // 👈 This ensures width is respected
  }}
>
  At Urban Casa, we are here to manage every aspect of your home construction or service process.
</Typography>

            <Box sx={{ mt: 2 }}>
  <IconButton
    component="a"
    href="https://www.facebook.com/urban.casa.7"
    target="_blank"
    rel="noopener noreferrer"
    sx={{ color: "white", "&:hover": { color: "#3b5998" } }}
  >
    <Facebook />
  </IconButton>
  <IconButton
    component="a"
    href="https://www.instagram.com/urban.casa13?igsh=aHFwcGM3MDFoNHZx"
    target="_blank"
    rel="noopener noreferrer"
    sx={{ color: "white", "&:hover": { color: "#c32aa3" } }}
  >
    <Instagram />
  </IconButton>

  {/* <IconButton
    component="a"
    href="https://twitter.com/yourhandle"
    target="_blank"
    rel="noopener noreferrer"
    sx={{ color: "white", "&:hover": { color: "#00acee" } }}
  >
    <Twitter />
  </IconButton> */}
{/* 
  <IconButton
    component="a"
    href="https://www.youtube.com/yourchannel"
    target="_blank"
    rel="noopener noreferrer"
    sx={{ color: "white", "&:hover": { color: "#FF0000" } }}
  >
    <YouTube />
  </IconButton>


  {/* <IconButton
    component="a"
    href="https://www.pinterest.com/yourpage"
    target="_blank"
    rel="noopener noreferrer"
    sx={{ color: "white", "&:hover": { color: "#BD081C" } }}
  >
    <Pinterest />
  </IconButton> */}
</Box>

          </Grid>

          {/* Middle Section - Subscribe */}
          {/* <Grid item xs={12} sm={3} mt={6}>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#A0FF74" }}>
              Subscribe to Fidel Build
            </Typography>
            <TextField
              variant="standard"
              placeholder="E-mail"
              fullWidth
              sx={{ mt: 1, borderBottom: "1px solid white", input: { color: "white" } }}
            />
            <Button
              variant="contained"
              sx={{
                mt: 2,
                bgcolor: "#A0FF74",
                color: "black",
                textTransform: "none",
                borderRadius: "20px",
                px: 3,
                "&:hover": { bgcolor: "#85e05d" },
              }}
            >
              Subscribe →
            </Button>
          </Grid> */}

          {/* Right Section - Links */}
         <Grid item xs={12} sm={2} mt={6}>
  <Typography variant="h6" sx={{ fontWeight: "bold", color: "#A0FF74" }}>
    Quick Links
  </Typography>
  {[
    { label: "Home", path: "/" },
    { label: "About", path: "/About-Urban-Casa" },
    { label: "Services", path: "/Services" },
    { label: "Custom Home", path: "/custom-homes" },
    { label: "Community Development", path: "/Community-Development" },
    { label: "Building Design", path: "/BuildingDesign" },
    { label: "Build With US", path: "/contact" },
  ].map((item, index) => (
    <Typography
      key={index}
      variant="body2"
      component="a"
      href={item.path}
      sx={{
        mt: 1,
        display: "block",
        color: "white",
        textDecoration: "none",
        cursor: "pointer",
        "&:hover": { color: "#A0FF74" },
      }}
    >
      {item.label}
    </Typography>
  ))}
</Grid>

          {/* Contact & Make Appointment */}
          <Grid item xs={12} sm={2} display="flex" alignItems="start" justifyContent="start"  gap={8} mt={6}>
            <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#A0FF74" }}>
              Contact
            </Typography>
            <Typography variant="body2" sx={{ display: "flex", alignItems: "center", mt: 1, opacity: 0.7 }}>
              <Email sx={{ mr: 1, fontSize: 18 }} /> urbancasaau@gmail.com
            </Typography>
            <Typography variant="body2" sx={{ display: "flex", alignItems: "center", mt: 1, opacity: 0.7 }}>
              <Phone sx={{ mr: 1, fontSize: 18 }} /> +61498283369
            </Typography>
            <Typography variant="body2" sx={{ display: "flex", alignItems: "center", mt: 1, opacity: 0.7 }}>
              <LocationOn sx={{ mr: 1, fontSize: 18 }} /> 21B Production Drive, Campbellfield
            </Typography>
            </Box>

           <Box>
  <Typography variant="h6" sx={{ fontWeight: "bold", color: "#A0FF74" }}>
    Make Appointment
  </Typography>
  {["Get In Touch"].map((item, index) => (
    <Typography
      key={index}
      variant="body2"
      component="a"
      href="/contact" // <-- Change path as needed
      sx={{
        mt: 1,
        color: "white",
        textDecoration: "none",
        cursor: "pointer",
        "&:hover": { color: "#A0FF74" },
      }}
    >
      {item}
    </Typography>
  ))}
</Box>
          </Grid>
        </Grid>

        {/* Divider */}
        <Divider sx={{ bgcolor: "#A0FF74", my: 3 }} />

        {/* Copyright Section */}
        <Typography variant="body2" textAlign="center" sx={{ opacity: 0.7 }}>
          Copyright ©{new Date().getFullYear()} – Urban Casa – All Rights Reserved.
        </Typography>
{/* 
        <Typography variant="body2" textAlign="center" sx={{ opacity: 0.5, mt: 1 }}>
          Design and Code by CodeArtistry
        </Typography> */}
      </Container>
    </Box>
  );
};

export default Footer;
